// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"b5fad9ec","142":"36579ed2","150":"cdf0ddf4","185":"bf0292b6","210":"8c023617","314":"e509c848","389":"dc8512bd","528":"f3248fb9","571":"2f47df02","912":"dc8512bd","954":"07d653ff"}[chunkId] + ".chunk.css";
};